<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>

        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div v-if="!answer[JsonFieldToDisplay()]"></div>
            <div v-if="question.showDate && question.showTime">
              <div class="mr-15">
                {{ dateFormat(answer[JsonFieldToDisplay()], question.dateFormat, answer) }}
                {{ getTime(answer[JsonFieldToDisplay()], question, answer) }}
                <ClockIconPopup :answer="answer.answerText" :id="answer.questionId" />
              </div>
            </div>

            <div v-else-if="question.showDate">
              <div>
                {{ dateFormat(answer[JsonFieldToDisplay()], question.dateFormat, answer, question) }}
              </div>
            </div>

            <div v-else-if="question.showTime">
              <div>
                {{ getTime(answer[JsonFieldToDisplay()], question, answer) }}
              </div>
            </div>
          </template>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
      <div class="d-flex"></div>
    </div>
    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable" :class="isQuestionSkipped() ? 'disable-question' : ''">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>

        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div class="date-time-edit-mode d-flex h-100-percent">
            <div v-if="question.showDate" class="mr-15 h-100-percent">
              <ParticipantDatePicker input-class="form-control" placeholder="Enter Date" v-model="updatedAns.date" :answer="answer" class="h-100-percent" @isDateValid="validateDate($event)" :updatedAns="updatedAns.date" @answerChanged="validateInput" />
            </div>
            <div v-if="question.showTime" :style="[answersLength - 1 == stepIndex ? { 'padding-bottom': '80px' } : {}]">
              <vue-timepicker :minute-interval="1" :disabled="answer && answer.isDisabled" v-model="updatedAns.time.value" :format="getTimeFormat()" @change="validateInput"></vue-timepicker>
            </div>
          </div>
          <span v-if="hasFieldError" class="text-danger pl-5 fw-bold pt-10">
            {{ fieldErrorText }}
          </span>
          <span v-else-if="hasFieldWarning" class="text-warning pl-5 fw-bold pt-10">
            {{ fieldWarningText }}
          </span>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30 current-answer">
                <div v-if="question.showDate && question.showTime">
                  <div class="mr-15">
                    {{ dateFormat(answer.answer_text, question.dateFormat, answer) }}
                    {{ getTime(answer[JsonFieldToDisplay()], question, answer) }}
                    <ClockIconPopup :answer="answer.answer_text" :id="`${answer.question_id}current`" />
                  </div>
                </div>

                <div v-else-if="question.showDate">
                  <div>
                    {{ dateFormat(answer[JsonFieldToDisplay()], question.dateFormat, answer, question) }}
                  </div>
                </div>

                <div v-else-if="question.showTime">
                  <div>
                    {{ getTime(answer[JsonFieldToDisplay()], question, answer) }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>

            <template v-if="answer && answer.privius_answer_text">
              <div class="previous-answer">
                <div div v-if="question.showDate && question.showTime">
                  <div class="mr-15">
                    {{ dateFormat(answer.privius_answer_text, question.dateFormat, answer) }}
                    {{ getTime(answer.privius_answer_text, question, answer) }}
                    <ClockIconPopup :answer="answer.privius_answer_text" :id="`${answer.question_id}privius`" />
                  </div>
                </div>

                <div v-else-if="question.showDate">
                  <div>
                    {{ dateFormat(answer.privius_answer_text, question.dateFormat, answer, question) }}
                  </div>
                </div>

                <div v-else-if="question.showTime">
                  <div>
                    {{ getTime(answer.privius_answer_text, question, answer) }}
                  </div>
                </div>
                <div class="row">
                  <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                    <label>Score</label>
                    <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                      {{ answer.privius_score }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
import moment from "moment";
import ParticipantDatePicker from "./date-picker-response";
import VueTimepicker from "vue2-timepicker";
import ClockIconPopup from "@/components/common/clock-icon-popup";

export default {
  name: "DateTimeResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: {
        date: {},
        time: {
          value: {}
        }
      },
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: "",
      fieldWarningText: "",
      allDateFormats: {
        "mm/dd/yyyy": "MM/DD/YYYY",
        "dd/mm/yyyy": "DD/MM/YYYY",
        "yyyy/mm/dd": "YYYY/MM/DD",
        "yyyy/mm": "YYYY/MM",
        "mm/yyyy": "MM/YYYY",
        "YYYY-MM-DD": "YYYY-MM-DD",
        yyyy: "YYYY"
      },
      dateObj: {
        month: "",
        date: "",
        year: ""
      },
      getDateFormatschecking: ["mm", "yyyy", "dd"],
      hasDate: false,
      hasMonth: false,
      hasYear: false,
      hasDateError: false,
      hasMonthError: false,
      hasYearError: false,
      hasTimeError: false
    };
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    validations: Object,
    usage: Object,
    stepIndex: Number,
    surveyData: Object,
    selectedLanguageCulture: String,
    activityType: String,
    answersLength: {
      type: Number,
      default: 0
    }
  },
  components: {
    ParticipantDatePicker,
    VueTimepicker,
    ClockIconPopup
  },
  watch: {
    mode() {
      if (this.mode == 1 && this.answer && this.answer.answerText) {
        const formattedDate = moment(this.answer.answerText).utcOffset(this.answer.participantLocalTimeOffset).format("DD-MM-YYYY");
        const splitDate = formattedDate.split("-");
        this.updatedAns.date = {
          date: parseInt(splitDate[0]),
          month: parseInt(splitDate[1] - 1),
          year: parseInt(splitDate[2])
        };
        if (!this.question.showDate) {
          const formattedTime = this.answer.answerText;
          const splitTime = formattedTime.split(/[ :]+/);
          this.updatedAns.time.value = this.question.timeFormat == 12 ? { hh: splitTime[0], mm: splitTime[1], A: splitTime[2] } : { HH: splitTime[0], mm: splitTime[1] };
        } else {
          const timeFormat = this.question.timeFormat == 12 ? "hh-mm-A" : "HH-mm";
          const formattedTime = moment(this.answer.answerText).utcOffset(this.answer.participantLocalTimeOffset).format(timeFormat);
          const splitTime = formattedTime.split("-");
          this.updatedAns.time.value = this.question.timeFormat == 12 ? { hh: splitTime[0], mm: splitTime[1], A: splitTime[2] } : { HH: splitTime[0], mm: splitTime[1] };
        }
      }
    },
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    }
  },
  mounted() {
    if (this.question.showDate) {
      this.setHasConditions();
    }
  },
  methods: {
    dateFormat(value, format, answer, question = {}) {
      let dateFormat = "";
      const { subType } = question;
      const participantLocalOffset = answer && answer.participantLocalTimeOffset ? answer.participantLocalTimeOffset : answer && answer.participant_local_time_offset ? answer.participant_local_time_offset : moment().format("Z") ;
      switch (format) {
        case "dd/mm/yyyy":
          dateFormat = "D MMMM YYYY";
          break;
        case "mm/dd/yyyy":
          dateFormat = "MMMM D YYYY";
          break;
        case "yyyy/mm/dd":
          dateFormat = "YYYY MMMM D";
          break;
        case "yyyy/mm":
          dateFormat = "YYYY MMMM";
          break;
        case "mm/yyyy":
          dateFormat = "MMMM YYYY";
          break;
        case "yyyy":
          dateFormat = "YYYY";
          break;
        default:
          dateFormat = "D MMMM YYYY";
      }
      if (subType === 'Date') {
        return moment(value).format(dateFormat);
      }
      return moment(value).utcOffset(participantLocalOffset).format(dateFormat);
    },
    getTime(val, question, answer) {
      let { timeFormat, subType } = question;
      const participantLocalOffset = answer && answer.participantLocalTimeOffset ? answer.participantLocalTimeOffset : answer && answer.participant_local_time_offset ? answer.participant_local_time_offset : moment().format("Z") ;
      timeFormat = timeFormat == 12 ? "hh:mm A" : "HH:mm";
      let formattedTimeValue = val;
      if (subType === "DateTime") {
        formattedTimeValue = moment(formattedTimeValue).utcOffset(participantLocalOffset).format(timeFormat);
      }
      const allPossibleFormats = ["hh:mm A", "HH:mm:ss A", "HH:mm", "HH:mm:ss"];
      const result = moment(formattedTimeValue, allPossibleFormats, true).isValid();

      if (!result) {
        return "";
      }

      const formattedTime = moment(formattedTimeValue).utcOffset(participantLocalOffset).format(timeFormat);
      if (formattedTime === "Invalid date") {
        if (timeFormat == "HH:mm") {
          return formattedTimeValue.replace(/PM/g, "");
        } else {
          return formattedTimeValue;
        }
      }
      return formattedTime;
    },
    getTimeFormat() {
      const timeFormat = this.question.timeFormat;
      if (timeFormat == 12) {
        return "hh:mm A";
      } else if (timeFormat == 24) {
        return "HH:mm";
      }
    },
    answerUpdated() {
      this.$emit(`answerChanged`, {
        questionId: this.question.id,
        newAns: this.updatedAns
      });
    },
    validateInput() {
      this.$nextTick(() => {
        if (this.question.showDate && this.question.showTime) {
          this.onDateObjChange();
          if (this.hasFieldError == false) {
            this.onTimeChange();
          }
          if (this.hasFieldError == false) {
            this.validateDateRules();
          }
          if (this.hasFieldError == false) {
            this.validateTimeRules();
          }
        } else if (this.question.showDate) {
          this.onDateObjChange();
          if (this.hasFieldError == false) {
            this.validateDateRules();
          }
        } else if (this.question.showTime) {
          this.onTimeChange();
          if (this.hasFieldError == false) {
            this.validateTimeRules();
          }
        }
        this.checkForFieldErrors();
        if (this.answer && this.hasFieldError == false) {
          this.answer.score = this.question.score;
          this.answer.computedScore = this.answer.score;
          this.answerUpdated();
        }
      });
    },
    onDateObjChange() {
      this.validateDate();
    },
    onTimeChange() {
      this.validateTime();
    },
    validateDate() {
      let { date, month, year } = this.updatedAns.date;
      month = month + 1;
      const { isSkippable } = this.question;
      this.resetDateValidations();
      if (this.hasDate && !date && !isSkippable) {
        this.hasDateError = true;
      }
      if (this.hasMonth && !month && !isSkippable) {
        this.hasMonthError = true;
      }
      if (this.hasYear && !year && !isSkippable) {
        this.hasYearError = true;
      }

      if (!this.hasDateError && !this.hasMonthError && !this.hasYearError) {
        this.hasFieldError = false;
        this.fieldErrorText = "";
        this.resetDateValidations();
      } else {
        this.hasFieldError = true;
        this.fieldErrorText = "This field is required.";
        return;
      }
    },
    validateDateRules() {
      const { showDateRange, dateRange } = this.question;
      const dateString = this.getDateStringFromDateObject(this.updatedAns.date, this.question.dateFormat);
      if (dateString == null && !this.isClearAnswer) {
        return true;
      }
      if (showDateRange) {
        let isDateWithinRange = false;
        if (dateRange == "0") {
          isDateWithinRange = this.validateDateRange();
        } else {
          isDateWithinRange = this.validateDateDeviation();
        }

        if (isDateWithinRange) {
          this.hasFieldError = false;
          this.fieldErrorText = "";
          this.resetDateValidations();
        } else {
          return;
        }
      }
    },
    validateDateRange() {
      let { startDate, endDate, dateFormat, useStartCurrentDate, useEndCurrentDate } = this.question;
      const { date, month, year } = this.updatedAns.date;
      const selectedDate = `${month + 1}/${date}/${year}`;
      dateFormat = this.allDateFormats[dateFormat];

      let startDateMoment = "";
      let endDateMoment = "";
      let granularity = "";

      if (this.hasDate) {
        granularity = "days";
      } else if (this.hasMonth) {
        granularity = "month";
      } else {
        granularity = "year";
      }

      if (useStartCurrentDate) {
        startDateMoment = moment(moment().format(dateFormat), dateFormat);
      } else {
        startDateMoment = moment(startDate, "YYYY-MM-DD");
      }

      if (useEndCurrentDate) {
        endDateMoment = moment(moment().format(dateFormat), dateFormat);
      } else {
        endDateMoment = moment(endDate, "YYYY-MM-DD");
      }
      const answerMoment = moment(selectedDate, dateFormat);

      if (answerMoment.isBetween(startDateMoment, endDateMoment, granularity, [])) {
        return true;
      } else {
        const startDateFormatted = startDateMoment.format(dateFormat);
        const endDateFormatted = endDateMoment.format(dateFormat);
        this.hasFieldError = true;
        this.fieldErrorText = `Enter a date in the range of ${startDateFormatted} - ${endDateFormatted}.`;
        return false;
      }
    },

    validateDateDeviation() {
      let { targetDate, daysBefore, daysAfter, dateFormat, useTargetCurrentDate } = this.question;
      dateFormat = this.allDateFormats[dateFormat];
      const { date, month, year } = this.updatedAns.date;
      const selectedDate = `${month + 1}/${date}/${year}`;
      const answerMoment = moment(moment(selectedDate).format(dateFormat), dateFormat);

      let granularity = "";

      if (this.hasDate) {
        granularity = "days";
      } else if (this.hasMonth) {
        granularity = "month";
      } else {
        granularity = "year";
      }

      let targetDateMoment = "";

      if (useTargetCurrentDate) {
        targetDateMoment = moment(moment().format(dateFormat), dateFormat);
      } else {
        targetDateMoment = moment(targetDate);
      }
      const startDateMoment = targetDateMoment.clone().subtract(Number(daysBefore), "days");
      const endDateMoment = targetDateMoment.clone().add(Number(daysAfter), "days");
      if (answerMoment.isBetween(startDateMoment, endDateMoment, granularity, [])) {
        return true;
      } else if (answerMoment.isBefore(startDateMoment, granularity)) {
        const startDateFormatted = startDateMoment.format(dateFormat);
        this.hasFieldError = true;
        this.fieldErrorText = `Enter a Date that begins ${startDateFormatted} or later.`;
        return false;
      } else if (answerMoment.isAfter(endDateMoment, granularity)) {
        const endDateFormatted = endDateMoment.format(dateFormat);
        this.hasFieldError = true;
        this.fieldErrorText = `Enter a Date no later than ${endDateFormatted}.`;
        return false;
      }
    },
    validateTime() {
      const { timeFormat, isSkippable } = this.question;
      const { hh, HH, mm, A } = this.updatedAns.time.value;

      this.hasFieldError = false;
      if (timeFormat == "12") {
        hh || hh === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
        if (!this.hasTimeError) {
          mm || mm === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
        }
        if (!this.hasTimeError) {
          A ? (this.hasTimeError = false) : (this.hasTimeError = true);
        }
      } else if (timeFormat == "24") {
        HH || HH === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
        if (!this.hasTimeError) {
          mm || mm === 0 ? (this.hasTimeError = false) : (this.hasTimeError = true);
        }
      }

      if (this.hasTimeError && !isSkippable) {
        this.hasFieldError = true;
        this.fieldErrorText = "This field is required.";
      }
    },
    validateTimeRules() {
      const { showTimeRange, timeRange } = this.question;
      if (showTimeRange) {
        let isTimeWithRange = false;

        if (timeRange == "0") {
          isTimeWithRange = this.validateTimeRange();
        }
        if (isTimeWithRange) {
          this.hasFieldError = false;
          this.fieldErrorText = "";
          this.resetTimeValidations();
        }
      } else {
        this.hasFieldError = false;
        this.fieldErrorText = "";
      }
    },
    validateTimeRange() {
      let { timeFormat, startTime, endTime } = this.question;

      timeFormat = timeFormat == "12" ? "hh:mm A" : "HH:mm";

      const startTimeMoment = moment(startTime, timeFormat);
      const endTimeMoment = moment(endTime, timeFormat);
      //
      const time = `${this.updatedAns.time.value.hh}-${this.updatedAns.time.value.mm}-${this.updatedAns.time.value.A}`;
      const answerMoment = moment(time, timeFormat);
      const granularity = "minutes";

      if (answerMoment.isBetween(startTimeMoment, endTimeMoment, granularity, [])) {
        return true;
      } else {
        const startDateFormatted = startTimeMoment.format(timeFormat);
        const endDateFormatted = endTimeMoment.format(timeFormat);
        this.hasFieldError = true;
        this.fieldErrorText = `Enter a time in the range of ${startDateFormatted} - ${endDateFormatted}.`;
        return false;
      }
    },
    resetTimeValidations() {
      this.hasTimeError = false;
    },
    getTimeStringFromTimeObject(event) {
      const timeFormat = this.question.timeFormat;
      const { HH, hh, mm, A } = event;
      let timeString = "";
      if (timeFormat == "12" && hh && mm && A) {
        timeString = `${hh}:${mm} ${A}`;
      }
      if (timeFormat == "24" && HH && mm) {
        timeString = `${HH}:${mm}`;
      }

      return timeString;
    },
    resetDateValidations() {
      this.hasDateError = false;
      this.hasMonthError = false;
      this.hasYearError = false;
    },
    setHasConditions() {
      if (this.question.showDate) {
        const dateFormat = this.question.dateFormat;
        if (dateFormat.includes("d")) {
          this.hasDate = true;
        }
        if (dateFormat.includes("m")) {
          this.hasMonth = true;
        }
        if (dateFormat.includes("y")) {
          this.hasYear = true;
        }
      }
    },
    getDateStringFromDateObject(dateObject, dateFormatOld) {
      let dateFormat = dateFormatOld;
      dateFormat = dateFormat || this.question.dateFormat;
      let dateString = "";
      dateFormat = this.allDateFormats[dateFormat];

      const momentDate = moment();

      if (this.hasDate) {
        if (dateObject.date) {
          dateString += `${dateObject.date}/`;
          momentDate.date(dateObject.date);
        } else {
          return null;
        }
      }
      if (this.hasMonth) {
        if (dateObject.month != null) {
          dateString += `${dateObject.month}/`;
          momentDate.month(dateObject.month);
        } else {
          return null;
        }
      }
      if (this.hasYear) {
        if (dateObject.year) {
          dateString += `${dateObject.year}`;
          momentDate.year(dateObject.year);
        } else {
          return null;
        }
      }
      dateString = momentDate.format(dateFormat);
      return dateString;
    },
    checkForFieldErrors() {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks && this.question.dataEditChecks.length > 0) {
        let softDataCheck = false;
        this.resetAllErrors();
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "LESS_THAN") {
              if (this.question.showDate && this.question.showTime) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let dateTimeValue = dateString + "T" + timeString + ":00.000Z";
                let isafter = moment(dateTimeValue).isAfter(this.question.dataEditChecks[k].value);
                if (isafter) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is greater than the expected range ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.question.showDate) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                let dateTimeValue = dateString + "T00:00:00.000Z";
                let isafter = moment(dateTimeValue).isAfter(this.question.dataEditChecks[k].value);
                if (isafter) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD");
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is greater than the expected range ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.question.showTime) {
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let isafter = moment(timeString).isAfter(this.question.dataEditChecks[k].value);
                if (isafter) {
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is greater than the expected range ${this.question.dataEditChecks[k].value}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              }
            } else if (this.question.dataEditChecks[k].type == "GREATER_THAN") {
              if (this.question.showDate && this.question.showTime) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let dateTimeValue = dateString + "T" + timeString + ":00.000Z";
                let isbefore = moment(dateTimeValue).isBefore(this.question.dataEditChecks[k].value);
                if (isbefore) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is less than the expected range ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.question.showDate) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                let dateTimeValue = dateString + "T00:00:00.000Z";
                let isbefore = moment(dateTimeValue).isBefore(this.question.dataEditChecks[k].value);
                if (isbefore) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD");
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is less than the expected range ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (this.question.showTime) {
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let isbefore = moment(timeString).isBefore(this.question.dataEditChecks[k].value);
                if (isbefore) {
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is less than the expected range ${this.question.dataEditChecks[k].value}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              }
            }
          } else {
            if (this.question.dataEditChecks[k].type == "LESS_THAN") {
              if (this.question.showDate && this.question.showTime) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let dateTimeValue = dateString + "T" + timeString + ":00.000Z";
                let isafter = moment(dateTimeValue).isAfter(this.question.dataEditChecks[k].value);
                if (isafter) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response less than: ${message}.`;
                  this.question.isSkippable = false;
                }
              } else if (this.question.showDate) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                let dateTimeValue = dateString + "T00:00:00.000Z";
                let isafter = moment(dateTimeValue).isAfter(this.question.dataEditChecks[k].value);
                if (isafter) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD");
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response less than: ${message}.`;
                  this.question.isSkippable = false;
                }
              } else if (this.question.showTime) {
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let isafter = moment(timeString).isAfter(this.question.dataEditChecks[k].value);
                if (isafter) {
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response less than: ${this.question.dataEditChecks[k].value}.`;
                  this.question.isSkippable = false;
                }
              }
            } else if (this.question.dataEditChecks[k].type == "GREATER_THAN") {
              if (this.question.showDate && this.question.showTime) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let dateTimeValue = dateString + "T" + timeString + ":00.000Z";
                let isbefore = moment(dateTimeValue).isBefore(this.question.dataEditChecks[k].value);
                if (isbefore) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD HH:mm");
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response greater than: ${message}.`;
                  this.question.isSkippable = false;
                }
              } else if (this.question.showDate) {
                const dateString = this.getDateStringFromDateObject(this.updatedAns.date, "YYYY-MM-DD");
                let dateTimeValue = dateString + "T00:00:00.000Z";
                let isbefore = moment(dateTimeValue).isBefore(this.question.dataEditChecks[k].value);
                if (isbefore) {
                  let message = this.$moment.utc(this.question.dataEditChecks[k].value).format("YYYY-MM-DD");
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response greater than: ${message}.`;
                  this.question.isSkippable = false;
                }
              } else if (this.question.showTime) {
                const timeFormat = this.getTimeFormat();
                const timeString = moment(this.getTimeStringFromTimeObject(this.updatedAns.time.value), timeFormat).format("HH:mm");
                let isbefore = moment(timeString).isBefore(this.question.dataEditChecks[k].value);
                if (isbefore) {
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response greater than: ${this.question.dataEditChecks[k].value}.`;
                  this.question.isSkippable = false;
                }
              }
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}

.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>